import Autosuggest from 'react-autosuggest'
import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import {Row, Col} from 'react-flexbox-grid'
import Loader from 'react-loader'
import ReactPlayer from 'react-player'
import config from 'config'
import format from '../../helpers/format'
import container from '../../helpers/container'
import analytics from '../../helpers/analytics'
import {
  ContainerDivs,
  Works,
  Link,
  LinkIcon,
  SocialButtons,
  DeforestationRiskSectorIconRow,
  ScreenedCompanies,
  GetStartedInput,
  FamilyGrid,
  BenchmarkGrid,
  TargetDateGrid,
  AutocompleteSearch,
  SrOnly,
  InlineSignup,
  InlineDonate,
  AykCtaPanel,
 } from '../../components'
import Styles from './Home.css'


@CSSModules(Styles, {allowMultiple:true})
export default class Home extends Component {
  constructor() {
    super()
    this.state = {
      title: 'Home',
      desc: '',
      url: config.domain
    }
  }

  //
  render() {
    const foeLogo = require('../../../static/images/img-foe-logo.png')
    const aysLogo = require('../../../static/images/AsYouSow_Logo_color.svg')
    const orangutanImg = require('../../../static/images/young-orangutan.jpg')

    return (
      <div styleName='main'>

        {
          container.helmet(
            this.state.title,
            this.state.desc,
            this.state.url
          )
        }

        <section styleName='hero'>
          <ContainerDivs>

            <div styleName='hero__content'>
              <h1 styleName='hero__headline'>
                We have the power to cut our financial ties to deforestation
              </h1>

              <p styleName='hero__search-subhead'>
                Check your mutual funds for deforestation-risk investments
              </p>
              <div styleName='hero__search-wrap'>
                <AutocompleteSearch />
              </div>

              <p styleName='hero__btn-subhead'>
                Find sustainable, deforestation-free mutual funds and ETFs
              </p>

              <div styleName='hero__btn-wrap'>
                <Link
                  to={config.routes.clean}
                  bigbutton
                  title='Top-scoring funds'
                >
                  Top-scoring funds<LinkIcon />
                </Link>
              </div>

              <div styleName='banner-logos-wrap'>
                <div styleName='banner-logos-copy'>
                  A project of
                </div>
                <div styleName='banner-logos'>
                  <img
                    src={aysLogo}
                    alt='As You Sow'
                    styleName='banner-logo-ays'
                  />
                  <SrOnly>As You Sow</SrOnly>
                  <img
                    src={foeLogo}
                    alt='Friends of the Earth'
                    styleName='banner-logo-foe'
                  />
                  <SrOnly>Friends of the Earth</SrOnly>
                </div>
              </div>
            </div>

          </ContainerDivs>

        </section>

        <AykCtaPanel />

        <section styleName='lede-section'>
          <ContainerDivs>

            <div styleName='media-react-player-wrap-wrap'>
              <div styleName='media-react-player-wrap'>
                <ReactPlayer
                  url='https://vimeo.com/433644374'
                  volume={0.5}
                />
              </div>
            </div>
            
            <h2 styleName='lede-section__headline'>
              Cut deforestation out of your portfolio
            </h2>

            <img
              src={orangutanImg}
              alt='Young orangutan'
              styleName='lede-section__image'
            />

            <p>
              Deforestation and degradation of vast swaths of land for commodities such as palm oil, pulp and paper, cattle, soy, timber, and rubber is responsible for almost one quarter of all global greenhouse gas emissions and for unprecedented species extinction. 
            </p>
            <p>
              Simultaneously, the occupation of vast areas of land for industrial plantation agriculture is a leading cause of violent land conflicts due to its frequent dispossession and displacement of local and indigenous communities. 
            </p>
            <p>
              Simply put, if we want to limit the catastrophic impacts of climate change, reduce our impact on the world’s biodiversity, and respect the rights of indigenous peoples, <strong>protecting the world’s remaining forests is key.</strong>
            </p>
            <p>
              Deforestation isn’t just bad for the planet. Increasingly, it’s risky business. Companies engaged in deforestation, land grabbing and human rights violations expose themselves and their shareholders to significant financial risks from stalled business operations, reputational damage, and legal liabilities. 
            </p>
            { /* <p>
              The industries that drive most deforestation, especially in the tropics, are palm oil, paper/pulp, rubber, timber, cattle, and soy. If it were up to you, your money probably wouldn’t be invested in these industries. But would you know it if it was? Your answer matters, because as Bill McKibben has said, <strong>"if it's wrong to wreck the planet, then it's wrong to profit from that wreckage."</strong>
            </p>
            <p>
              Deforestation Free Funds can help get your money out of deforestation.
            </p> */ }
            <p>
              <b>Deforestation Free Funds</b> is a search platform that informs and empowers everyday people, consumers, and investors to make decisions aligned with their values. It lets you see if your savings are invested in companies and sectors driving deforestation, shows you how to take action to get fund managers to implement more sustainable investment policies, and helps you find investment options that support an environmentally-friendly future.
            </p>

            <div styleName='lede-section__btn-wrap'>
              <div styleName='lede-section__btn'>
                <Link
                  to={config.routes.clean}
                  roundbutton
                  title='Fund database'
                >
                  Fund database<LinkIcon />
                </Link>
              </div>

              <div styleName='lede-section__btn'>
                <Link
                  to={config.routes.toolkit}
                  roundbutton
                  title='Action toolkit'
                >
                  Action toolkit<LinkIcon />
                </Link>
              </div>
            </div>

            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <InlineSignup />
            <br/>
            <br/>
            <br/>
            <br/>

          </ContainerDivs>
        </section>

        <Works/>

        <section styleName='sectors-section'>
          <ContainerDivs>
            <h2 styleName='sectors-section__headline'>
              Supply chains driving forest loss
            </h2>
            <p styleName='sectors-section__text'>
              Global deforestation is heavily driven by demand for agricultural commodities.
              Vast areas of tropical rainforest are destroyed
              for <strong>palm oil</strong>, <strong>cattle</strong>
              , <strong>soy</strong>, <strong>rubber</strong>
              , <strong>timber</strong>, and <strong>paper/pulp</strong>.
              Many global brands have pledged to reduce deforestation risk, but progress remains slow.
            </p>
            <DeforestationRiskSectorIconRow/>
            { /* <ScreenedCompanies/> */ }
            <div styleName='sectors-section__btn'>
              <Link
                to={config.routes.companies}
                roundbutton
                title='See companies'
              >
                See companies<LinkIcon />
              </Link>
            </div>

          </ContainerDivs>
        </section>
        

        <ContainerDivs>
          <br/>
          <br/>
          <br/>
          <br/>
          <br/>
          <br/>
          <br/>
          <InlineDonate />
          <br/>
          <br/>
          <br/>
        </ContainerDivs>

        { /* 
        <br/>
        <GetStartedInput />
        <BenchmarkGrid />
        <TargetDateGrid />
        <br/>
        <FamilyGrid />
        <GetStartedInput />
        */ }

      </div>
    )
  }
}

